export enum ADDRESS_LABELS {
  ADDRESS_LINE_1 = 'Address line 1',
  ADDRESS_LINE_2 = 'Address line 2',
  ADDRESS_LINE_3 = 'Address line 3',
  CITY = 'City',
  COUNTY = 'County',
  POSTCODE = 'Postcode',
}

export enum ADDRESS_NAMES {
  ADDRESS_LINE_1 = 'addressLine1',
  ADDRESS_LINE_2 = 'addressLine2',
  ADDRESS_LINE_3 = 'addressLine3',
  CITY = 'city',
  COUNTY = 'county',
  POSTCODE = 'postcode',
}
